const ITEMS = [
    "$BALD",
    "BALD PIGEON",
    "JUST A BALD PIGEON ON SOLANA",
    "NO HAIR",
    "NO BRAKES",
    "JUST MEMES",
    "$BALD",
    "BALD PIGEON",
];

function Row({ hidden = false }) {
    return (
        <div className="flex shrink-0 items-center" aria-hidden={hidden}>
            {ITEMS.map((item, i) => (
                <span key={`${item}-${i}`} className="flex items-center">
                    <span
                        className={`headline whitespace-nowrap px-6 text-lg md:text-2xl ${
                            item.startsWith("$") ? "text-gradient" : "text-white/85"
                        }`}
                    >
                        {item}
                    </span>
                    <span className="text-purple-400/70 text-sm md:text-base">✦</span>
                </span>
            ))}
        </div>
    );
}

export default function Ticker() {
    return (
        <div
            data-testid="ticker-bar"
            className="relative z-10 -rotate-1 scale-[1.02] overflow-hidden border-y border-cyan-400/15 bg-gradient-to-r from-[#04060D] via-[#0A0E1A] to-[#04060D] py-4"
        >
            <div className="marquee-track">
                <Row />
                <Row hidden />
            </div>
        </div>
    );
}
